/**
 * Shared by the section tables so their column labels line up with the section
 * heading above them. MUI pads a `TableCell` horizontally, which indents the
 * first column past the heading and pulls the last one in from the action
 * button's right edge; zeroing the outer two restores both margins to the
 * card's own padding.
 *
 * Lives in its own module rather than beside `ProfileSection` so that file only
 * exports components — mixing a constant in defeats Vite's Fast Refresh and
 * forces a full reload on every edit to it.
 */
export const PROFILE_TABLE_SX = {
  "& th:first-of-type, & td:first-of-type": { pl: 0 },
  "& th:last-of-type, & td:last-of-type": { pr: 0 },
} as const;
